import React, { useCallback, useState } from 'react';

const useModalState = () => {
   const [isOpen, setIsOpen] = useState(false);

   const closeModal = useCallback(() => {
      setIsOpen(false);
   }, []);

   const openModal = useCallback(() => {
      setIsOpen(true);
   }, []);

   const toggleModal = useCallback(() => {
      setIsOpen((prevState) => !prevState);
   }, []);

   return ({
      isOpen,
      closeModal,
      openModal,
      toggleModal,
   });
};

export default useModalState;
